import * as angular from 'angular';
import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { StartRecordingButton } from './StartRecordingButton';

angular
  .module('flowingly.runner.library')
  .component('startRecordingButton', react2angular(StartRecordingButton, []));
